// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NapnGYrcy8rDumt9{height:100%;width:100%;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;padding-top:16px}.NapnGYrcy8rDumt9 .afmmjlDMlt8_axuC{height:264px;width:100%}.NapnGYrcy8rDumt9 .ctYsSJURDwNHV6Tx{height:100%;display:flex;justify-content:center;align-items:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardBody": `NapnGYrcy8rDumt9`,
	"scatterChart": `afmmjlDMlt8_axuC`,
	"spinner": `ctYsSJURDwNHV6Tx`
};
export default ___CSS_LOADER_EXPORT___;
